var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Resources;
(function (Resources) {
    var Localization = (function () {
        function Localization() {
            this['navMenuName'] = 'Dividend';
            this['filterStart'] = 'Start:';
            this['filterEnd'] = 'End:';
            this['ticker'] = 'Ticker';
            this['name'] = 'Name';
            this['period'] = 'Period';
            this['amount'] = 'Amount';
            this['annualDividendYield'] = 'Annual Dividend Yield';
            this['exDividendDate'] = 'Ex-Dividend Date';
            this['recordDate'] = 'Record Date';
            this['payDate'] = 'Payable Date';
            this['periods'] = {
                'none': '',
                'monthly': 'Monthly',
                'quarterly': 'Quarterly',
                'triAnnual': 'Tri-annual',
                'semiAnnual': 'Semi-annual',
                'annual': 'Annual',
                'unknown': 'Unknown'
            };
            this['countries'] = {
                'ca': 'Canada',
                'us': 'United States'
            };
            this['invalidIdentifier'] = 'Symbol is invalid';
        }
        Localization = __decorate([
            InoCore.resourceKey(InoCore.Types.Language.English, "dividend"),
            __metadata("design:paramtypes", [])
        ], Localization);
        return Localization;
    }());
})(Resources || (Resources = {}));
var Resources;
(function (Resources) {
    var Localization = (function () {
        function Localization() {
            this['navMenuName'] = 'Dividendes';
            this['filterStart'] = 'Début :';
            this['filterEnd'] = 'Fin :';
            this['ticker'] = 'Symbole';
            this['name'] = 'Nom';
            this['period'] = 'Fréquence';
            this['amount'] = 'Montant';
            this['yield'] = 'Rendement';
            this['annualDividendYield'] = 'Rendement du Dividende Annuel';
            this['exDividendDate'] = 'Date de détachement du dividende';
            this['recordDate'] = 'Date d\'enregistrement';
            this['payDate'] = 'Date de paiement';
            this['periods'] = {
                'none': '',
                'monthly': 'Mensuelle',
                'quarterly': 'Trimestrielle',
                'triAnnual': 'Quadrimestrielle',
                'semiAnnual': 'Semestrielle',
                'annual': 'Annuelle',
                'unknown': 'Inconnue'
            };
            this['countries'] = {
                'ca': 'Canada',
                'us': 'États-Unis'
            };
            this['invalidIdentifier'] = 'Symbole invalide';
        }
        Localization = __decorate([
            InoCore.resourceKey(InoCore.Types.Language.French, "dividend"),
            __metadata("design:paramtypes", [])
        ], Localization);
        return Localization;
    }());
})(Resources || (Resources = {}));
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var InoCalendar;
(function (InoCalendar) {
    var Addons;
    (function (Addons) {
        var Dividend;
        (function (Dividend_1) {
            var Components;
            (function (Components) {
                var Dividend;
                (function (Dividend) {
                    var DividendViewModel = (function (_super) {
                        __extends(DividendViewModel, _super);
                        function DividendViewModel(defaultCountry, defaultDate, dividendService) {
                            var _this = _super.call(this) || this;
                            _this.init = function () {
                                _this.fetchDividends();
                            };
                            _this.dividendService = _this.validateAndNormalizeDividendServiceParameter(dividendService);
                            _this.dividends = ko.observableArray([]);
                            _this.sortedHeader = ko.observable(null);
                            _this.isAsc = ko.observable(null);
                            _this.search = ko.observable('');
                            _this.country = ko.observable(_this.validateAndNormalizeDefaultCountryParameter(defaultCountry));
                            _this.country.subscribe(function () { _this.fetchDividends(); });
                            _this.countries = ['ca', 'us'];
                            _this.sector = ko.observable(null);
                            _this.sectors = InoCalendar.Helpers.SectorHelper.getSectors();
                            _this.sector(_this.sectors[0]);
                            _this.filteredDividends = ko.pureComputed(function () { return _this.applyFilters(_this.dividends()); });
                            _this.selectedDate = ko.observable(_this.validateAndNormalizeDefaultDateParameter(defaultDate).format('YYYY-MM-DD'));
                            _this.selectedDate.subscribe(function (value) {
                                _this.fetchDividends();
                            });
                            InoCore.Services.EventsHandlerService.subscribe([InoCalendar.Types.Event.LoadChangedDate], function () { _this.selectDate(moment(InoCalendar.Services.CalendarContextService.selectedDate)); }, InoCore.Types.EventState.After);
                            return _this;
                        }
                        DividendViewModel.prototype.applyFilters = function (dividends) {
                            var _this = this;
                            var sectorFilter = this.sector();
                            if (sectorFilter && sectorFilter.id) {
                                var sectorFilterParsed = parseInt(sectorFilter.id);
                                dividends = dividends.filter(function (x) { return x.sectorId == sectorFilterParsed; });
                            }
                            var searchFilter = (this.search() || '').toLowerCase();
                            if (searchFilter) {
                                dividends = dividends.filter(function (x) { return _this.getSearchTextIndexFromDividendModel(x).indexOf(searchFilter) > -1; });
                            }
                            return dividends;
                        };
                        DividendViewModel.prototype.sortOn = function (property) {
                            return function () { return this[property]; };
                        };
                        DividendViewModel.prototype.selectDate = function (date) {
                            var normalizedDate = this.fallbackWeekendDaysToLastFriday(date);
                            var formattedDate = normalizedDate.format('YYYY-MM-DD');
                            this.selectedDate(formattedDate);
                        };
                        DividendViewModel.prototype.fetchDividends = function () {
                            var _this = this;
                            this.dividendService.getDividend(this.country(), this.selectedDate()).then(function (data) {
                                _this.dividends(data);
                                var sortedHeader = _this.sortedHeader();
                                if (sortedHeader)
                                    ko.bindingHandlers.sortable.sort(sortedHeader.sortableFor, _this.dividends, _this.isAsc());
                            }).catch(function () {
                                InoCore.Services.EventsHandlerService.trigger(InoCalendar.Types.Event.UnhandledError);
                            });
                        };
                        DividendViewModel.prototype.validateAndNormalizeDividendServiceParameter = function (parameter) {
                            if (parameter === null || parameter === undefined)
                                throw ('dividendService Parameter is required to initialize DividendViewModel');
                            return parameter;
                        };
                        DividendViewModel.prototype.validateAndNormalizeDefaultCountryParameter = function (parameter) {
                            if (!parameter)
                                throw ('defaultCountry parameter is required to initialize DividendViewModel');
                            return parameter;
                        };
                        DividendViewModel.prototype.validateAndNormalizeDefaultDateParameter = function (parameter) {
                            if (parameter === null || parameter === undefined)
                                throw ('defaultDate parameter is required to initialize DividendViewModel');
                            return this.fallbackWeekendDaysToLastFriday(parameter);
                        };
                        DividendViewModel.prototype.fallbackWeekendDaysToLastFriday = function (date) {
                            var momentDate = moment(date);
                            if (momentDate.get('weekday') === 0)
                                momentDate.add(-2, 'days');
                            if (momentDate.get('weekday') === 6)
                                momentDate.add(-1, 'days');
                            return momentDate;
                        };
                        DividendViewModel.prototype.getSearchTextIndexFromDividendModel = function (dividend) {
                            var textIndex = '';
                            textIndex += dividend.symbol || '';
                            textIndex += dividend.stockName || '';
                            textIndex += this.resources().dividend.periods[dividend.frequency] || '';
                            return textIndex.toLowerCase();
                        };
                        DividendViewModel.prototype.beforeRouteEnter = function (_a) {
                            var id = _a.id;
                        };
                        DividendViewModel.prototype.beforeRouteLeave = function () {
                        };
                        return DividendViewModel;
                    }(InoCore.Components.Basic.BaseViewModel));
                    Dividend.DividendViewModel = DividendViewModel;
                })(Dividend = Components.Dividend || (Components.Dividend = {}));
            })(Components = Dividend_1.Components || (Dividend_1.Components = {}));
        })(Dividend = Addons.Dividend || (Addons.Dividend = {}));
    })(Addons = InoCalendar.Addons || (InoCalendar.Addons = {}));
})(InoCalendar || (InoCalendar = {}));
var InoCalendar;
(function (InoCalendar) {
    var Addons;
    (function (Addons) {
        var Dividend;
        (function (Dividend) {
            var Config = (function () {
                function Config() {
                    this['dividendRelativeUrl'] = 'stocks/CountryDividendCalendar?country={country}&date={date}';
                }
                Config = __decorate([
                    InoCore.config(),
                    __metadata("design:paramtypes", [])
                ], Config);
                return Config;
            }());
            Dividend.Config = Config;
        })(Dividend = Addons.Dividend || (Addons.Dividend = {}));
    })(Addons = InoCalendar.Addons || (InoCalendar.Addons = {}));
})(InoCalendar || (InoCalendar = {}));
var InoCalendar;
(function (InoCalendar) {
    var Addons;
    (function (Addons) {
        var Dividend;
        (function (Dividend) {
            var Types;
            (function (Types) {
                var RequestStatus;
                (function (RequestStatus) {
                    RequestStatus["None"] = "none";
                    RequestStatus["InvalidIdentifier"] = "invalidIdentifier";
                    RequestStatus["Success"] = "success";
                })(RequestStatus = Types.RequestStatus || (Types.RequestStatus = {}));
            })(Types = Dividend.Types || (Dividend.Types = {}));
        })(Dividend = Addons.Dividend || (Addons.Dividend = {}));
    })(Addons = InoCalendar.Addons || (InoCalendar.Addons = {}));
})(InoCalendar || (InoCalendar = {}));
var InoCalendar;
(function (InoCalendar) {
    var Addons;
    (function (Addons) {
        var Dividend;
        (function (Dividend_2) {
            var Models;
            (function (Models) {
                var Dividend = (function () {
                    function Dividend() {
                        this.originalLoadedData = null;
                        this.requestStatus = InoCalendar.Addons.Dividend.Types.RequestStatus.None;
                        this.stockName = null;
                        this.symbol = null;
                        this.ticker = null;
                        this.exchange = null;
                        this.sectorId = null;
                        this.frequency = null;
                        this.amount = null;
                        this.currency = null;
                        this.exDate = null;
                        this.recordDate = null;
                        this.payDate = null;
                        this.type = null;
                        this.annualDividendYield = null;
                    }
                    ;
                    Dividend.prototype.fromJSON = function (data) {
                        this.originalLoadedData = data;
                        this.requestStatus = data.requestStatus;
                        this.stockName = data.stockName;
                        this.symbol = data.symbol;
                        this.ticker = data.ticker;
                        this.exchange = data.exchange;
                        this.sectorId = data.sectorId;
                        this.annualDividendYield = data.annualDividendYield ? data.annualDividendYield / 100 : null;
                        this.frequency = data.payment.frequency;
                        this.amount = data.payment.amount;
                        this.currency = data.payment.currency;
                        this.exDate = data.payment.exDate ? new Date(data.payment.exDate) : null;
                        this.recordDate = data.payment.recordDate ? new Date(data.payment.recordDate) : null;
                        this.payDate = data.payment.payDate ? new Date(data.payment.payDate) : null;
                        this.type = data.payment.type;
                    };
                    Dividend.prototype.toJSON = function () {
                        return null;
                    };
                    Dividend.prototype.generateRedirectURL = function () {
                        var redirectUrl = InoCore.Services.ConfigurationManager.AppSettings('dividendRedirectUrl');
                        if (redirectUrl == null || this.symbol == null)
                            return null;
                        return inovestor.ms.core.stringFormat(redirectUrl, {
                            symbol: encodeURIComponent(this.symbol),
                            category: 'stock'
                        });
                    };
                    return Dividend;
                }());
                Models.Dividend = Dividend;
            })(Models = Dividend_2.Models || (Dividend_2.Models = {}));
        })(Dividend = Addons.Dividend || (Addons.Dividend = {}));
    })(Addons = InoCalendar.Addons || (InoCalendar.Addons = {}));
})(InoCalendar || (InoCalendar = {}));
var InoCalendar;
(function (InoCalendar) {
    var Addons;
    (function (Addons) {
        var Dividend;
        (function (Dividend) {
            var Services;
            (function (Services) {
                var DividendService = (function () {
                    function DividendService() {
                        this.dataService = new InoCore.Services.DataService(InoCore.Services.ConfigurationManager.AppSettings('dividendDataServiceAppData'));
                    }
                    DividendService.prototype.getDividend = function (country, date) {
                        var _this = this;
                        return new Promise(function (resolve, reject) {
                            var options = {
                                type: 'GET',
                                contentType: 'application/json'
                            };
                            var dividendRelativeUrl = inovestor.ms.core.stringFormat(InoCore.Services.ConfigurationManager.AppSettings('dividendRelativeUrl'), {
                                country: country,
                                date: date
                            });
                            _this.dataService.sendRequestAsync(dividendRelativeUrl, options)
                                .then(function (msCoreXHR) {
                                var dividends = Array();
                                var data = msCoreXHR.data;
                                data.items.forEach(function (dividendJSON) {
                                    var dividend = new InoCalendar.Addons.Dividend.Models.Dividend();
                                    dividend.fromJSON(dividendJSON);
                                    dividends.push(dividend);
                                });
                                resolve(dividends);
                            }).catch(function (msCoreXHR) {
                                reject();
                            });
                        });
                    };
                    return DividendService;
                }());
                Services.DividendService = DividendService;
            })(Services = Dividend.Services || (Dividend.Services = {}));
        })(Dividend = Addons.Dividend || (Addons.Dividend = {}));
    })(Addons = InoCalendar.Addons || (InoCalendar.Addons = {}));
})(InoCalendar || (InoCalendar = {}));
var InoCalendar;
(function (InoCalendar) {
    var Addons;
    (function (Addons) {
        var Dividend;
        (function (Dividend_3) {
            var Components;
            (function (Components) {
                var Dividend;
                (function (Dividend) {
                    var DividendComponent = (function (_super) {
                        __extends(DividendComponent, _super);
                        function DividendComponent(templateUrl) {
                            if (templateUrl === void 0) { templateUrl = "inoMsCalendar.addons.dividend.dividend.component.html"; }
                            var _this = this;
                            var defaultCountry = InoCore.Services.ConfigurationManager.AppSettings('dividendDefaultCountry') || 'ca';
                            var defaultDate = InoCore.Services.ConfigurationManager.AppSettings('dividendDefaultDate') || moment();
                            _this = _super.call(this, "dividend", templateUrl, new InoCalendar.Addons.Dividend.Components.Dividend.DividendViewModel(defaultCountry, defaultDate, new InoCalendar.Addons.Dividend.Services.DividendService())) || this;
                            _this.isRegistered = false;
                            return _this;
                        }
                        DividendComponent.prototype.render = function () {
                            var _this = this;
                            return new Promise(function (resolve, reject) {
                                _this.viewModel.init();
                                _this.getTemplateAsync().then(function (template) {
                                    _this.registerView(template);
                                    resolve();
                                });
                            });
                        };
                        DividendComponent.prototype.registerView = function (template) {
                            if (this.isRegistered)
                                return;
                            _super.prototype.registerView.call(this, template);
                            this.isRegistered = true;
                        };
                        DividendComponent.prototype.beforeRouteEnter = function (params) {
                            this.viewModel.beforeRouteEnter(params);
                        };
                        DividendComponent.prototype.beforeRouteLeave = function () {
                            this.viewModel.beforeRouteLeave();
                        };
                        return DividendComponent;
                    }(InoCore.Components.Basic.BaseComponent));
                    Dividend.DividendComponent = DividendComponent;
                })(Dividend = Components.Dividend || (Components.Dividend = {}));
            })(Components = Dividend_3.Components || (Dividend_3.Components = {}));
        })(Dividend = Addons.Dividend || (Addons.Dividend = {}));
    })(Addons = InoCalendar.Addons || (InoCalendar.Addons = {}));
})(InoCalendar || (InoCalendar = {}));
var InoCalendar;
(function (InoCalendar) {
    var Addons;
    (function (Addons) {
        var Dividend;
        (function (Dividend) {
            var addonKey = 'dividend';
            var viewId = 'dividend';
            var defaultOptions = {
                dividendComponentFactory: function (defaultFactory) { return defaultFactory(); },
                install: $.noop
            };
            InoCalendar.AddonsService.register(addonKey, {
                install: function (config, context) {
                    var extendedOptions = $.extend(true, {}, defaultOptions, config);
                    var addonContext = {};
                    context.router.addRoutes([
                        { name: 'calendar.dividend', path: '/calendar/dividend', view: viewId }
                    ]);
                    context.view.registerView({
                        id: viewId,
                        resourceKey: 'dividend.navMenuName',
                        component: extendedOptions.dividendComponentFactory(function () {
                            return new InoCalendar.Addons.Dividend.Components.Dividend.DividendComponent();
                        })
                    });
                    context.calendarNavigation.addView(viewId);
                    extendedOptions.install(addonContext, context);
                }
            });
        })(Dividend = Addons.Dividend || (Addons.Dividend = {}));
    })(Addons = InoCalendar.Addons || (InoCalendar.Addons = {}));
})(InoCalendar || (InoCalendar = {}));
